"use strict";

module.exports = function (accumulator, order, product, component) {
  var numToAdd = 0;

  if (component.quantity + component.extra_blanks > 5) {
    numToAdd = component.num_to_add == null ? 4 : component.num_to_add;
  }

  var qplus = parseInt(component.quantity, 10) + parseInt(component.extra_blanks, 10) + numToAdd;
  var price = 0;

  if (component.guest_addressing || component.return_addressing || component.name_printing) {
    if (qplus < 30) {
      price = 5;
    } else if (qplus < 200) {
      price = 30;
    } else {
      price = 30 + (Math.floor(qplus / 100) - 1) * 5;
    }

    if (component.print_flap_open && parseInt(component.quantity, 10) > 5) {
      price += 5;
    }
  }

  return accumulator + price;
};